import { render, staticRenderFns } from "./ConnectionAccounts.vue?vue&type=template&id=54a0b666&"
import script from "./ConnectionAccounts.vue?vue&type=script&lang=js&"
export * from "./ConnectionAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports